module.exports = __webpack_public_path__ + "static/img/2001.596d3f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2001.jpg
// module id = 292
// module chunks = 0